export default {
  text: 'black',
  primary: '#d0b886',
  secondary: '#91805d',
  background: 'white',
  backgroundSecondary: '#d9c69e',
  light: '#FFF',
  dark: '#202020'
}
